import request from '@/common/request'
import { ItemDoCarrinho } from '@/models/venda/Carrinho'

const basePath = '/item-carrinho'

export const salvarOuAtualizarItemDoCarrinho = (carrinhoId: string, item: ItemDoCarrinho): Promise<boolean> =>
	request.post(`${basePath}/${carrinhoId}/salvar-ou-atualizar`, item)

export const removerItemDoCarrinho = (produtoId: string, carrinhoId: string): Promise<void> =>
	request.post(`${basePath}/${produtoId}/${carrinhoId}/remover`)
